import { html } from "lit";

export interface ServiceReportsProps {
    /**
     * Locale for the form
     */
    locale?: string;
    /**
     * Environment configuration
     */
    env?: "dev" | "qa" | "prod";
    /**
     * Use legacy API
     */
    legacyApi?: boolean;
    /** MachineNumber */
    machineNumber?: string;
    /** MissionNumber */
    missionNumber?: string;
    /** TechnicianName */
    technicianName?: string;
    /** MachineAlias */
    machineAlias?: string;
    /** MachineName */
    machineName?: string;
}

/**
 * Service Reports Micro Frontend
 */
export const ServiceReportsTemplate = ({
    locale,
    env,
    legacyApi,
    machineNumber,
    missionNumber,
    technicianName,
    machineAlias,
    machineName
}: ServiceReportsProps) => {
    return html`
        <mf-service-reports
            locale="${locale}"
            env="${env}"
            ?legacy-api=${legacyApi}
            machine-number="${machineNumber}"
            mission-number="${missionNumber}"
            technician-name="${technicianName}"
            machine-alias="${machineAlias}"
            machine-name="${machineName}"
        >
        </mf-service-reports>
    `;
};
